<style scoped xmlns="http://www.w3.org/1999/html">

    @import "./index.css";

    .imgCover {
        opacity: .3
    }

</style>

<template>
    <div id="app">

        <div class="ww_left">
            <div style="height: 13%">
                <span class="left-title" id="gk">概况</span>
                <span class="middle-title" style="position: absolute;left: 1%;top: 45px;">项目名称：{{userInfo.nickName}}</span>
                <span class="middle-title" style="position: absolute;left: 1%;top: 65px;" @click="selectArea()">区域名称：{{areaName}}
                <Icon type="ios-arrow-down" size="15" color="#FFFFFF"/>
                </span><br>
                <span class="middle-title" style="position: absolute;float: right;top: 45px;left: 60%">{{getday}}</span>
                <span class="middle-title" style="position: absolute;float: right;top: 65px;left: 60%">{{getweek}}</span>
                <span class="middle-title" style="position: absolute;float: right;top: 80px;left: 60%;font-size: 25px;font-weight: bold;">{{gettime}}</span>
            </div>
            <div style="height: 25%;">
                <span class="left-title" id="zhpg" @click="btChange('zhpg')" style="background-color: rgba(200, 200, 200, 0.1)">智慧喷灌</span>
                <div style="width: 10%;margin-top:100px;float: left;margin-left: 1%">总体概况</div>
                <div style="width: 48%;height: calc(100% - 90px);margin-top:70px;float: left;">
                    <div v-for="(item, index) in sprayStatusList" style="height: 100%;float: left;">
                        <div style="height: calc(100% - 40px);width: 53px;display: flex; align-items: center; justify-content: center">
                            <Progress  vertical :percent=item.num :stroke-color=item.color :stroke-width="18" status="active"><Icon type="checkmark-circled"></Icon></Progress>
                        </div>
                        <span style="text-align:center;display:block;margin-top: 10px" >{{item.name}}</span>
                        <span style="text-align:center;display:block;margin-top: 5px;" :style="{'color': item.color}" >{{item.vdef}}</span>
                    </div>
                </div>
                <div style="width: 40%;height: 60%;margin-top:10%;float: left;">
                    <div v-for="(item, index) in sprayProportionList" style="width: 100%;height: 30%;float: left;">
                        <span style="margin-top: 5px" >{{item.name}}：{{item.vdef}}</span>
                        <div style="height: 15px;display: flex; align-items: center; justify-content: center">
                            <Progress :percent=item.num  :stroke-width="10" status="active" stroke-color='#ffffff'></Progress>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 37%;">
                <span class="left-title" id="trgl" @click="btChange('trgl')">土壤管理</span>
                <div style="width: 60%;height: calc(100% - 40px);margin-top:30px;float: left;">
                    <!--左侧传感器当前数据-->
                    <div class="view2">
                        <div class="item">
                            <span  class="view1_span">土壤湿度</span>
                            <div id="ww_echart_center_TR_1" style="width: 50%;height: 100%;">
                            </div>
                            <span  class="view1_span_right">土壤肥力</span>
                            <div id="ww_echart_center_TR_2" style="width: 50%;height: 100%;">
                            </div>
                        </div>
                    </div>
                    <!--左侧传感器历史数据-->
                    <div class="view3" style="float: left;">
                        <!--<div v-if="JSON.stringify(sensorRecordList[0]) == '{}'"-->
                             <!--style="height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">-->
                            <!--<div style="line-height: 100%; text-align: center">-->
                                <!--<Icon style="font-size: 10px; color:#ddd" type="ios-paper-plane-outline"/>-->
                                <!--<br/>暂无传感器历史数据-->
                            <!--</div>-->
                        <!--</div>-->
                        <div id="ww_echart_0"  :key="0" class="item"></div>
                    </div>
                </div>
                <!--左侧环形进度条，固定-->
                <div style="width: 40%;height: calc(100% - 60px);margin-top:50px;float: left;">
                    <div v-if="JSON.stringify(llSensor) == '{}'" class="sensor_circle">
                        <i-circle :percent=0 :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">--<br/>实时流量</span>
                        </i-circle>
                    </div>
                    <div v-else class="sensor_circle">
                        <i-circle :percent=llSensor.value :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">{{llSensor.value}}<br/>{{llSensor.deviceName}}</span>
                        </i-circle>
                    </div>
                    <div v-if="JSON.stringify(ylSensor) == '{}'" class="sensor_circle">
                        <i-circle :percent=0 :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">--<br/>实时雨量</span>
                        </i-circle>
                    </div>
                    <div v-else class="sensor_circle">
                        <i-circle :percent=ylSensor.value :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">{{ylSensor.value}}<br/>{{ylSensor.deviceName}}</span>
                        </i-circle>
                    </div>
                    <div v-if="JSON.stringify(trwdSensor) == '{}'" class="sensor_circle">
                        <i-circle :percent=0 :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">--<br/>土壤温度</span>
                        </i-circle>
                    </div>
                    <div v-else class="sensor_circle">
                        <i-circle :percent=trwdSensor.value :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">{{trwdSensor.value}}<br/>{{trwdSensor.deviceName}}</span>
                        </i-circle>
                    </div>
                    <div v-if="JSON.stringify(kqsdSensor) == '{}'" class="sensor_circle">
                        <i-circle :percent=0 :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">--<br/>空气湿度</span>
                        </i-circle>
                    </div>
                    <div v-else class="sensor_circle">
                        <i-circle :percent=kqsdSensor.value :size="70">
                            <span class="demo-Circle-inner" style="font-size:12px">{{kqsdSensor.value}}<br/>{{kqsdSensor.deviceName}}</span>
                        </i-circle>
                    </div>
                </div>
            </div>
            <div style="height: 25%;">
                <div style="width: 48%;height: 100%;float:left;">
                    <span class="left-title" id="zhyh" style="width: 46%" @click="btChange('zhyh')">智慧养护</span>
                    <div style="width: 45%;height: calc(100% - 30px);margin-top:30px;margin-left: 1%;float:left;">
                        <div v-if="maintainList.length <= 0"
                             style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">
                            <div style="line-height: 100%; text-align: center">暂无养护数据</div>
                        </div>
                        <div v-else v-for="(item, index) in maintainList" style="height: calc(50% - 10px);margin-top: 10px;">
                            <span>{{item.maintainType}}</span><br/>
                            <span>养护周期:{{item.timeInterval}}</span><br/>
                            <span>上次养护日期:<br/>{{item.lastTime.substr(0, 10)}}</span>
                        </div>
                    </div>
                    <div style="width: 54%;height: calc(100% - 30px);margin-top:30px;float:left;">

                    </div>
                </div>
                <div style="width: 50%;height: 100%;float:left;">
                    <span class="left-title" id="zhdg" style="width: 50%;left: 48%" @click="btChange('zhdg')">智慧灯光</span>
                    <div class="view4">
                        <div style="display: inline-block;height: 80px;margin-left: 5px;">
                            <span class="dl-title">用电量统计:暂无数据</span><br/>
                            <span class="dl-title" >节能方案:暂无数据</span>
                        </div>
                        <div class="itemdg">
                            <div v-if="switchDeviceList.length <= 0"
                                 style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">
                                <div style="line-height: 100%; text-align: center">暂无设备</div>
                            </div>
                            <vue-seamless-scroll v-else :data="switchDeviceList" style="height: 100%;overflow: hidden;" :class-option="optionSingleHeightTime">
                                <!--<ul class="item">-->
                                    <li  class="item_i" v-for="(item, index) in switchDeviceList">
                                        <img :src="item.deviceImg ? imgSrc+item.deviceImg : nopic" alt="" style="height: 17px;"
                                             @click="see(item)">
                                        <span class="sm-title" style="color: white">{{item.deviceName}}</span>
                                        <span class="sm-title" style="color: white;">运行状态:
                                          <span v-if="!item.status" class="sm-title" style="color: yellow;">异常</span>
                                          <span v-else-if="item.switchStatus" class="sm-title" style="color: #00FF7F;">开启</span>
                                          <span v-else class="sm-title" style="color: white;">关闭</span>
                                        </span>
                                        <span class="sm-title" style="color: white;">运行时间:{{getHour(item.totalRunning)}}H</span>
                                    </li>
                                <!--</ul>-->
                            </vue-seamless-scroll>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="ww_middle">
            <div class="ww_head">

                <img :src=bgPic alt='' id="pic"  style="position: absolute;z-index:-1;top: 0;left: -15%;width: 130%;height: 100%">

                <div @contextmenu.prevent="showMenu" style="position: absolute;z-index:2500;top: 0;left: 0;width: 100%;height: 100%;"></div>
                <div class="title">瀚云智慧景观控制中心</div>
                <div style="position: absolute;z-index:2501;left: 90%;top: 15px;">
                    <Upload class=""
                            action=""
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload">
                        <Button icon="ios-cloud-upload-outline"></Button>
                    </Upload>
                </div>
                <div style="width: 100px;float:left;position: absolute;z-index:2;left: 10%;top: 70px;font-size: 10px;color: #FFFFFF;">当前人数：-人</div>
                <div style="width: 120px;float:left;position: absolute;z-index:2500;left: 70%;top: 70px;font-size: 10px;color: #FFFFFF;">
                    占地面积：{{areaNum}}㎡
                    <Icon  type="md-create" size=15 @click="modifiesArea"></Icon>
                </div>
                <div style="width: 200px;float:left;position: absolute;z-index:2;left: 10%;top: 80%;">
                    <img src="./assets/img/yl_ico.png" alt="" style="width: 40px;position: absolute;z-index:2;left: 0px;">
                    <div style="position: absolute;z-index:2;float:left;left: 40px;font-size: 10px;color: #FFFFFF;text-align:left;">
                        <span>雨量统计：100ml/年</span><br/><span>雨量大小：中</span>
                    </div>
                </div>
            </div>
            <div style="height: 25%;">
                <div style="width: 33%;height: 100%;float:left;">
                    <span class="left-title" id="cjgl" style="width: 32%">场景管理</span>
                    <div class="view1">
                        <div v-if="sceneCatList.length <= 0"
                             style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">
                            <div style="line-height: 100%; text-align: center">暂无场景</div>
                        </div>
                        <div v-else class="item" v-if="sceneCatList.length>0&&index<3" v-for="(item, index) in sceneCatList"
                             class-name="item">
                            <!--<div>-->
                                <div style="width: 54px;height: 100%;float: left;font-size: 8px;color: #FFFFFF;display: flex; align-items: center; justify-content: center;">
                                    <span style="width: 50px">{{item.sceneCatName}}</span>
                                    <div style="width: 4px;height: 60%;float: left;;background-color: #3EEDEE"></div>
                                </div>

                                <div class="menu" class-name="item">
                                    <div class="menu_i" v-for="(item2, index2) in item.sceneList" v-if="index2<4">
                                        <div class="menu_i_bg"><img :src="item2.sceneImg ? imgSrc+item2.sceneImg : nopic" alt="" @click="editScene(item2)"
                                                                    :class="item2.sceneOpen==1 ? '' : 'imgCover'"
                                                                    style="width: 30px;height: 30px;"></div>
                                        <div class="menu_i_title"
                                             style="display: flex;flex-direction: row;align-items: center;justify-content: center">
                                            <span>{{item2.sceneName}}</span>
                                            <Icon type="ios-power" size="13" color="#fff" style="margin-left: 5px"
                                                  @click="onOpen(item2)"/>
                                        </div>
                                    </div>
                                </div>
                            <!--</div>-->
                        </div>
                    </div>
                </div>
                <div style="width: 66%;height:100%;float:left;">
                    <span class="left-title" id="fwgl" style="width: 64%;left: 34%" @click="btChange('fwgl')">氛围管理</span>
                    <div class="view4">
                        <div class="view4-item-title">
                            <span class="sm-title">调光类</span>
                            <span class="sm-title">调色类<span class="sm-ftitle"></span></span>
                        </div>

                        <div class="item">
                            <div v-if="kttgDeviceList.length <= 0"
                                 style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">
                                <div style="line-height: 100%; text-align: center">暂无设备</div>
                            </div>
                            <vue-seamless-scroll v-else :data="kttgDeviceList" style="height: 100%;overflow: hidden;" :class-option="optionSingleHeightTime">
                                    <li class="item_i" v-for="(item, index) in kttgDeviceList">
                                        <img :src="item.deviceImg ? imgSrc+item.deviceImg : nopic" alt="" @click="see(item)" style="height: 17px;">
                                        <span class="sm-title" style="color: white;">{{item.deviceName}}</span>
                                        <span class="sm-title" style="color: white;">运行状态:
                                         <span v-if="!item.status" class="sm-title" style="color: yellow;">异常</span>
                                         <span v-else-if="item.switchStatus" class="sm-title" style="color: #00FF7F;">开启</span>
                                         <span v-else class="sm-title" style="color: white;">关闭</span></span>
                                        <span class="sm-title" style="color: white;">运行时间:{{getHour(item.totalRunning)}}H</span>
                                    </li>
                            </vue-seamless-scroll>

                        </div>
                        <div class="item">
                            <div v-if="kttsDeviceList.length <= 0"
                                 style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">
                                <div style="line-height: 100%; text-align: center">暂无设备</div>
                            </div>
                            <vue-seamless-scroll v-else :data="kttsDeviceList" style="height: 100%;overflow: hidden;" :class-option="optionSingleHeightTime">
                                    <li  class="item_i" v-for="(item, index) in kttsDeviceList">
                                        <img :src="item.deviceImg ? imgSrc+item.deviceImg : nopic" alt="" @click="see(item)" style="height: 17px;">
                                        <span class="sm-title" style="color: white">{{item.deviceName}}</span>
                                        <span class="sm-title" style="color: white;">运行状态:
                                         <span v-if="!item.status" class="sm-title" style="color: yellow;">异常</span>
                                         <span v-else-if="item.switchStatus" class="sm-title" style="color: #00FF7F;">开启</span>
                                         <span v-else class="sm-title" style="color: white;">关闭</span>
                                        </span>
                                        <span class="sm-title" style="color: white;">运行时间:{{getHour(item.totalRunning)}}H</span>
                                    </li>
                            </vue-seamless-scroll>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ww_right">
            <div style="height: 50%;width: 100%">
                <span class="left-title" id="hjgl" @click="btChange('hjgl')">环境管理</span>
                <div style="width: 100%;height: 40%;padding-top:40px;">
                    <div style="width: 100%;height: 20px;float: left;">
                        <div style="width: 50%;float: left;padding-left: 60px;">
                            <span style="float: left;width: 112px">空气质量指数：{{hjMassList[0].vdef}}</span>
                            <div style="height: 20px;width: calc(100% - 112px);float: left;display: flex; align-items: center; justify-content: center">
                                <Progress :percent=hjMassList[0].num :stroke-color=hjMassList[0].color :stroke-width="8" status="active"><Icon type="checkmark-circled"></Icon></Progress>
                            </div>
                        </div>
                        <div style="width: 50%;float: left;padding-left: 60px;">
                            <span style="float: left;width: 112px">水体质量指数：{{hjMassList[1].vdef}}</span>
                            <div style="height: 20px;width: calc(100% - 112px);float: left;display: flex; align-items: center; justify-content: center">
                                <Progress :percent=hjMassList[1].num :stroke-color=hjMassList[1].color :stroke-width="8" status="active"><Icon type="checkmark-circled"></Icon></Progress>
                            </div>
                        </div>
                    </div>
                    <div style="width: 50%;height: calc(100% - 25px);float: left;">
                        <!--右侧传感器当前数据-->
                        <div class="view2" style="height: calc(100% - 5px)">
                            <div class="item">
                                <span  class="view1_span">空气PM2.5</span>
                                <div id="ww_echart_center_HJ_1" style="width: 50%;height: 100%;"></div>
                                <span class="view1_span_right">水体导电率</span>
                                <div id="ww_echart_center_HJ_2" style="width: 50%;height: 100%;"></div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 8%;height: calc(100% - 25px);float: left"></div>
                    <div style="width: 40%;height: calc(100% - 25px);float: left">
                        <div v-for="(item, index) in rightSensorList" style="width: 50%;height: 50%;float: left;display: flex; align-items: center; justify-content: center;">
                            <i-circle :percent=item.info.value :size="50">
                                <div class="demo-Circle-custom">
                                    <h1>{{item.info.value}}</h1>
                                    <p>{{item.deviceName}}</p>
                                </div>
                                <!--<span class="demo-Circle-inner" style="font-size:4px">{{item.info.value}}<br/>{{item.deviceName}}</span>-->
                            </i-circle>
                        </div>
                    </div>
                </div>
                <!--右侧传感器历史数据-->
                <div class="view3">
                    <!--<div v-if="sensorRecordList.length <= 1"-->
                         <!--style=" height:100%; font-size: 6px; color:#ddd; display: flex; align-items: center; justify-content: center" class="item ">-->
                        <!--<div style="line-height: 100%; text-align: center">-->
                            <!--<Icon style="font-size: 10px; color:#ddd" type="ios-paper-plane-outline"/>-->
                            <!--<br/>暂无传感器历史数据-->
                        <!--</div>-->
                    <!--</div>-->
                    <div id="ww_echart_1"  :key="1" class="item3" ></div>
                    <div id="ww_echart_2"  :key="2" class="item3" ></div>
                    <div id="ww_echart_3"  :key="3" class="item3" ></div>
                    <div id="ww_echart_4"  :key="4" class="item3" ></div>
                </div>


            </div>
            <div style="height: 25%;">
                <span class="left-title" id="nygl" @click="btChange('nygl')">能源管理</span>
                <!--75fb07-->
                <div style="width: 22%;height: calc(100% - 50px);float: left;margin-top: 50px;font-size: 15px;color: #FFFFFF;display: flex; align-items: center; justify-content: center;">
                    <span>省电模式：</span><span style="color:#75fb07">开启</span>
                </div>
                <div style="width: 40%;height: calc(100% - 50px);float: left;margin-top: 50px;font-size: 15px;color: #FFFFFF;display: flex; align-items: center; justify-content: center;">
                    <span>电力节约力度：</span><span style="color:#75fb07;font-size: 45px">36.2%</span>
                </div>
                <div style="width: 30%;height: calc(100% - 70px);margin-top:50px;float: left;background-color: rgba(34, 75, 143, 0.2);">
                    <div v-for="(item, index) in powerList" style="height: 95%;float: left;">
                        <div style="height: calc(100% - 50px);width: 40px;margin-top: 30px;display: flex; align-items: center; justify-content: center">
                            <Progress vertical :percent=item.num status="active" :stroke-color=item.color :stroke-width="13"><Icon type="checkmark-circled"></Icon></Progress>
                        </div>
                        <span style="text-align:center;display:block;margin-top: 10px" >{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div style="height: 25%;">
                <span class="left-title" id="sxt" @click="btChange('sxt')">摄像头</span>
                <div style="width: 70%;height: calc(100% - 35px);margin-top: 35px;float: left;">
                    <div v-if="camerasDeviceList.length<=0" v-for="index in 2" style="width: 50%;height: 100%;float: left;">
                        <video  style="width: calc(100% - 5px); height: calc(100% - 30px);margin-left: 2px" controls playsInline webkit-playsinline autoplay></video>
                        <div style="width: 100%;height: 30px;">摄像头</div>
                    </div>
                    <div  v-for="(item, index) in camerasDeviceList" style="width: 50%;height: 100%;float: left;">
                        <video id="myPlayer"  style="width: calc(100% - 5px); height: calc(100% - 30px);margin-left: 2px" controls playsInline webkit-playsinline autoplay>
                            <source :src="item.dinfo.rtmp" type="rtmp/flv" />
                            <source :src="item.dinfo.liveAddress" type="application/x-mpegURL" />
                        </video>
                        <div style="width: 100%;height: 30px;">{{item.deviceName}}</div>
                    </div>
                </div>
                <div class="view5">
                        <!--<span class="sm-title" style="margin-left: 15px;">{{musicDevice.deviceName}}</span>-->
                        <div class="item">
                            <!--<Slider v-model="musicInfo.progress" :min="0" :max="100" bar-height="1px"-->
                                    <!--@on-change="progressChange"-->
                                    <!--style="height:10px;width:90%;display:inline-block;padding-left: 15px">-->
                            <!--</Slider>-->
                            <div style="height: 30px;display: flex;flex-direction: row;justify-content: center;align-items: center;position: relative;">
                                <!--<span style="margin-left: 5px"><Icon type="md-repeat" size=20 color="#fff" @click="modePopShow=!modePopShow"></Icon></span>-->
                                <Icon  type="ios-skip-backward" style="margin-left: 10px" size=20 @click="lastSong"></Icon>
                                <span  v-model="musicInfo.statu" style="margin-left: 10px" @click="playOnOut">
                                        <Icon v-if="!musicInfo.statu" type="ios-play" size=36></Icon>
                                        <Icon v-else type="ios-pause" size=36></Icon>
                                    </span>
                                <Icon  type="ios-skip-forward" size=20 @click="nextSong"></Icon>

                                <span style="margin-left: 10px;"><Icon type="md-volume-down" size=20 color="#fff"></Icon></span>
                                <span><Slider v-model="musicInfo.volume" :min="0" :max="100"
                                            bar-height="1px"
                                            @on-change="volumeChange"
                                            style="height:30px;width:40px;display: inline-block;"></Slider>
                                </span>
                            </div>
                            <div style="height: 20px;display: flex;flex-direction: row;justify-content: space-around;align-items: center;position: relative;">
                                <span v-model="musicInfo.filePath"  class="li-title">{{musicInfo.filePath}}</span>
                                <!--<span @click="see(musicDevice)" style="position: absolute;right: 10px;"><Icon type="ios-list" size=30></Icon></span>-->
                            </div>
                            <!--目录返回-->
                            <div  style="position: relative;left: 1%;width: 90px;">
                                <img v-if="page>1" style="width: 20px;height: 15px;" src="@/assets/img//last.png" @click="lastPage">
                                <span>歌曲列表</span>
                            </div>

                            <div style="width: 100%;height:calc(100% - 70px);margin-top: 5px;position: relative;">
                                <vue-seamless-scroll v-if="sdList.length>0" :data="sdList" style="height: 100%;overflow: hidden;" :class-option="optionSingleHeightTime">
                                    <div v-for="(item,index) in sdList" :key="index">
                                        <li  tapmode="active-style" @click="nextPage(item,index)" style="height: 20px;width: 100%;">
                                            <span class="li-title">{{item}}</span>
                                            <Icon v-if="item.split('.').length==1" type="ios-arrow-forward" @click="playOnOut"  style="float:right;padding-right: 3px;" size=20></Icon>
                                            <!--<img v-if="item.split('.').length==1" src="@/assets/img//ic_right.png" @click="playOnOut"  style="height: 20px;float:right;padding-right: 10px">-->
                                        </li>
                                    </div>
                                </vue-seamless-scroll>
                                <!--没有目录-->
                                <p v-else style="text-align: center; padding: 20px 0; color:#cecece">暂无内容</p>

                            </div>


                        </div>
                    </div>

            </div>
        </div>
        <!--中间设备坐标显示-->
        <div v-for="(item,index) in menuList" :key="index" >
            <div v-if="isSensor(item)" v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">
                <div v-if="item.info.valueType=='trsd'">
                    <img v-show="item.info.statusTitle.indexOf('干旱') != -1" src="./assets/img/trsd_gh_ico.png" alt="">
                    <img v-show="item.info.statusTitle.indexOf('内涝') != -1" src="./assets/img/trsd_nl_ico.png" alt="">
                    <img v-show="item.info.statusTitle.indexOf('适宜') != -1" src="./assets/img/trsd_yl_ico.png" alt="">
                </div>
                <div v-if="item.info.valueType=='trfl'">
                    <img src="./assets/img/trfl_ico.png" alt="">
                </div>
                <li>
                    <span>{{item.deviceName}}</span><br/>
                    <span style="color: white;">当前数值:
                        <span  style="color: #21FFFF;">{{item.info.value}}</span>
                    </span><br/>
                    <span>土壤状态：
                        <span  style="color: #00FF7F">{{item.info.statusTitle}}</span>
                    </span>
                </li>
            </div>
            <div v-else v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">
                <img src="./assets/img/switch_ico.png" alt="">
                <li>
                    <span>{{item.deviceName}}</span><br/>
                    <span style="color: white;">状态:
                      <span v-if="!item.status" class="sm-title" style="color: yellow;">异常</span>
                      <span v-else-if="item.switchStatus" class="sm-title" style="color: #00FF7F;">开启</span>
                      <span v-else class="sm-title" style="color: white;">关闭</span>
                    </span>
                </li>
            </div>
        </div>
        <!--右键菜单-->
        <div v-show="visible" :style="{left:axisX+'px',top:axisY+'px'}" style="overflow-y: auto;height: 400px;width: 230px" class="contextmenu">
            <div v-if="menuList.length>0">
                <ul  v-for="(item,index) in menuList" :key="index">
                    <li class="menu_item" @click="savedata(item)" style="float: left;height: 30px">{{item.deviceName}}</li>
                    <img v-if="item.axisX" src="@/assets/img/error.png" @click="deleteDevice(item,index)" style="width: 30px;height: 30px;padding:5px;float: right">
                </ul>
            </div>
            <div v-else>
                <ul>
                    <li class="menu_item">该栏目暂无设备</li>
                </ul>
            </div>
        </div>
        <!--右侧弹出窗口-->
        <Drawer :title="sceneWinTitle" width="750" v-model="sceneShow" @on-close="onSceneClose">
            <!--<dscjAdd  v-if="type === 1" @close="onClose"></dscjAdd>-->
            <!--<dscjEdit v-if="type === 2" :itemval="itemVal" @close="onClose"></dscjEdit>-->
            <sceneShow v-if="sceneType === 1" :itemval="itemVal" @close="onSceneClose"></sceneShow>
            <sceneShow v-if="sceneType === 2" :itemval="itemVal" @close="onSceneClose"></sceneShow>
        </Drawer>
        <!--右侧弹出窗口-->
        <Drawer @on-close="onClose" :title="winTitle" :width="400" v-model="show">
            <dscjShow v-if="type === 2" :sbinfo="sbInfo" @close="onClose"></dscjShow>
            <areaPop v-if="type === 1" @close="onClose" @dapingRefresh="dapingRefresh"></areaPop>
            <dscjMusic v-if="type === 3" :sbinfo="musicDevice" @close="onClose" @updateSong="updateSong"></dscjMusic>
        </Drawer>
    </div>
</template>

<script>
    import { fullScreen } from "../layout/components/headerBar_components";
    import nopic from '@/assets/img/no_pic.png';
    import bgPic from './assets/img/bg.jpg';
    import * as echarts from 'echarts';
    import videojs from 'video.js';
    import echartUtil from '../../assets/js/DapingEchartUntil';
    import 'video.js/dist/video-js.css';
    import dscjMusic from "../znsb/music";
    import dscjShow from "../znsb/show";
    import sceneShow from "../zncj/add";
    import areaPop from "./area";
    export default {
        name: "daping",
        components: {
            dscjMusic, areaPop, dscjShow,sceneShow,fullScreen
        },
        data() {
            // 统计图对象
            return {
                userInfo: this.$func.data.get("userInfo"),
                isFullScreen:false,
                playMode: -1,// 播放模式
                page:0,
                path:'',
                songIndex: 0,
                sdList:[],
                dataList:[],
                modePopShow: false,
                loopModeList: ['正常', '单曲循环', '列表循环'],
                sceneShow: false,
                sceneWinTitle: "",
                itemVal: {},
                sceneType: 0,
                type: 0,// 右侧弹出类型
                winTitle: "",
                progress: 0, //音乐滑条进度
                musicDevice: {},
                sbInfo: {},
                musicInfo: {progress: 0, filePath: "未播放歌曲", time: "0",cha:2,volume:20,statu:0},
                show: false,// 侧边栏
                getday:'',
                weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
                sensorStandardList:[],
                powerList:[{name:"庭院灯",num:60,color:"#65c294"},{name:"高杆灯",num:85,color:"#50b7c1"},{name:"水泵",num:50,color:"#65c294"},{name:"电磁阀",num:80,color:"#50b7c1"},{name:"调色灯",num:30,color:"#65c294"}],
                sprayStatusList:[{name:"喷灌状态",num:70,vdef:"优",color:"#00FF01"},{name:"土壤墒情",num:0,vdef:"--",color:"#FE6601"},{name:"肥力状态",num:0,vdef:"--",color:"#FE6601"}],
                hjMassList:[{num:0,vdef:"一般",color:"#22FF04"},{num:0,vdef:"一般",color:"#21FFFF"}],
                sprayProportionList:[{name:"节水比例",num:36,vdef:"高"},{name:"喷灌比例",num:97,vdef:"高"},{name:"喷灌强度",num:40,vdef:"高"}],
                trSensorList:[],//土壤传感器
                kqSensorList:[],//空气类传感器
                szSensorList:[],//水质类传感器
                rightSensorList:[{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0}],//右侧传感器数组
                sensorRecordList:[],//传感器历史记录数组
                maintainList:[],//养护数组
                trsdSensorList:[],
                trflSensorList:[],
                llSensor:{},
                ylSensor:{},
                trwdSensor:{},
                kqsdSensor:{},
                pmSensor:{},
                ddlSensor:{},
                llSensorList:[],
                zhpgDeviceList:[],//智慧喷灌中设备数组
                trglDeviceList:[],//土壤管理中设备数组
                hjglDeviceList:[],//环境管理中设备数组
                fwglDeviceList:[],//氛围管理中设备数组
                columnID:'zhpg',//当前栏目id
                getweek:'',
                gettime:'',
                startDate: '2019-05-10',
                endDate: '2019-05-16',
                sensorList: [],
                areaId: 0,
                areaName: '切换区域',
                //图片
                nopic: nopic,
                bgPic: bgPic,
                imgSrc: this.$func.imgSrc,
                sceneCatList: [],
                list: [],
                switchDeviceList: [],//  开关类 （eid 含 znmb  relay valve）
                kttsDeviceList: [],//  调色 （eid 含 ktts）
                kttgDeviceList: [], // 调光 （eid 含 kttg）
                camerasDeviceList: [],//摄像头
                sxtDeviceList: [],//摄像头中设备数组
                nyglDeviceList: [],//能源管理中设备数组

                // 统计图对象数组
                centerChartTR: [],
                centerChartHJ: [],
                centerChartLSJL:[],
                audioPlayer4: null,

                //  (菜单数据)
                menuList:[],//当前栏目设备数组
                visible: false,
                axisX:0,
                axisY:0,
                mapId:1,
                mapUrl:'',
                areaNum:0,
                deviceAxisList:[],

            }
        },
        computed: {
            optionSingleHeightTime () {
                return {
                    step: 0.15, //数值越大速度滚动越快，默认0.3
                    limitMoveNum: 1, //开始无缝滚动的数据量，默认5
                }
            }
        },
        beforeCreate() {
            //设置背景色
            document.querySelector("body").setAttribute("style", "background:#fbfbfb");
        },
        beforeDestroy() {
            //去除背景色
            document.querySelector("body").setAttribute("style", "");
        },
        beforeMount() {

        },
        created(){
            var that = this;
            that.endDate = new Date();
            var y = that.endDate.getFullYear();
            var m = that.endDate.getMonth() + 1;
            var d = that.endDate.getDate() - 5;
            console.log("打印d*********");
            console.log(d);
            if(d<=0){
                d=30;
                m=m-1;
            }
            console.log(m);
            console.log(d);
            if (m < 10) {
                m = "0" + m;
            }
            if (d < 10) {
                d = "0" + d;
            }
            that.startDate = y + '-' + m + '-' + d;
            console.log(that.startDate);
            that.columnID='zhpg';
            that.listArea();
            setInterval(function () {
                that.dateRefresh();
            }, 10*1000)
        },

        mounted() {
        },
        watch: {
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu)
                } else {
                    document.body.removeEventListener('click', this.closeMenu)
                }
            }
        },
        methods: {
            modifiesArea(){
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                    title: '占地面积',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: name,
                                autofocus: true,
                                placeholder: '请输入占地面积',
                                maxlength: 10
                            },
                            on: {
                                input: (val) => {
                                    newVal = val
                                }
                            }
                        })
                    },
                    onOk: () => {
                        that.$func.ajax('addAreaMap', {
                            mapId:that.mapId,
                            areaId:that.$store.state.app.areaId,
                            imgUrl: that.mapUrl,
                            area:newVal
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message);
                            } else {
                                that.$Message.success(r.message);
                                that.areaNum=newVal;
                            }
                        })
                    }
                })
            },
            //上传地图之前
            beforeAvatarUpload(file) {
                console.log(file)
                if(file.type.indexOf('image')!=-1){
                    let reader = new FileReader();
                    var that=this
                    reader.onload = function (evt) {
                        let base64 = evt.target.result;
                        that.updatePic(base64);
                    };
                    reader.readAsDataURL(file);
                }else{
                    this.$Notice.warning({
                        title: '文件格式不正确',
                        desc: '文件格式 ' + file.name + ' 不正确, 请选择 jpg 或 png'
                    });
                }


                return true;
            },
            updatePic(base64){
                let that = this;
                that.$Message.loading({
                    content: '上传中...',
                    duration: 0
                });
                that.$func.ajax('upImg',{
                    token : that.$func.getUserInfo('token'),
                    img64 : base64,
                },function(r){
                    that.$Message.destroy()
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        console.log(r.type)
                        that.mapUrl="http://xhjg.oss-cn-beijing.aliyuncs.com"+r.type;
                        that.addAreaMap();
                    }
                },'','post',false)
            },
            getColumnDate() {
                var that=this;
                switch (that.columnID) {
                    case 'zhpg':
                        that.menuList =that.zhpgDeviceList;
                        break;
                    case 'trgl':
                        that.menuList =that.trglDeviceList;
                        break;
                    case 'hjgl':
                        that.menuList =that.hjglDeviceList;
                        break;
                    case 'zhdg':
                        that.menuList =that.switchDeviceList;
                        break;
                    case 'fwgl':
                        that.menuList =that.fwglDeviceList;
                        break;
                    case 'sxt':
                        that.menuList =that.sxtDeviceList;
                        break;
                }
                that.menuList.map(function (item, index){
                    if(item.axisX){
                        item.axisX='';
                        item.axisY='';
                    }
                    that.deviceAxisList.map(function (item1, index1){
                        if(item.deviceId==item1.deviceId && that.mapId==item1.mapId){
                            //既可以新增属性,又可以触发视图更新
                            that.$set(that.menuList[index],"axisX", item1.axisX);
                            that.$set(that.menuList[index],"axisY", item1.axisY);
                            //更新坐标时用到id
                            that.$set(that.menuList[index],"mapDeviceId", item1.id);
                        }
                    })
                })
                console.log("打印menuList*********");
                console.log(that.menuList);
            },
            closeMenu() {
                this.visible = false;
            },
            showMenu() {
                var that=this;
                that.visible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
                that.visible = true; // 显示模态窗口，跳出自定义菜单栏
                event.preventDefault();
                that.axisX=event.clientX;
                that.axisY=event.clientY;
                console.log("打印xy*********");
                console.log(that.axisX);
                console.log(that.axisY);

            },
            savedata(item) {
//                alert("保存");
                console.log(item);
                var that=this;
                that.$func.ajax('saveMapDevice', {
                    id:item.mapDeviceId,
                    mapId: that.mapId,
                    deviceId: item.deviceId,
                    axisX: that.axisX,
                    axisY: that.axisY
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        that.getAreaMapDevice();
//                        setTimeout(function () {
//                            that.getColumnDate();
//                        },1000)
                    }
                })
            },
            deleteDevice(item1,index){
                var that = this;
                console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
                that.$func.ajax('delAreaMapDevice', {
                    id:item1.mapDeviceId,
                    mapId: that.mapId,
                    deviceId: item1.deviceId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        setTimeout(function () {
                            that.getAreaMapDevice();
                        },6000)

                    }
                })
            },
            //获取地图
            getAreaMap() {
                var that=this;
                that.$func.ajax('listAreaMap', {
                    areaId: that.$store.state.app.areaId,
                    type:0
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        if(r.type.length>0){
                            document.getElementById("pic").src = r.type[r.type.length-1].imgUrl;
                            that.mapUrl=r.type[r.type.length-1].imgUrl;
                            that.mapId=r.type[r.type.length-1].mapId;
                            that.areaNum=r.type[r.type.length-1].area;
                            that.getAreaMapDevice();
                        }
                    }
                })
            },
            //获取地图下的设备
            getAreaMapDevice() {
                var that=this;
                that.$func.ajax('listAreaMapDevice', {
                    mapId: that.mapId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.deviceAxisList=r.type;
                        that.getColumnDate();

                    }
                })
            },
            //添加地图
            addAreaMap() {
                var that=this;
                that.$func.ajax('addAreaMap', {
                    areaId:that.$store.state.app.areaId,
                    imgUrl: that.mapUrl,
                    area:that.areaNum,
                    type:0
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        document.getElementById("pic").src = that.mapUrl;
                        that.dapingRefresh();
                    }
                })
            },
            //栏目标题单选效果
            btChange(id){
                // 设置当前点中div的背景颜色
                var that = this;
                that.columnID=id;
                that.getColumnDate();
                document.getElementById(id).style.backgroundColor='rgba(200, 200, 200, 0.1)';
                var list=document.getElementsByClassName("left-title");//获取class相同的所有span
                for(var i=0;i<list.length;i++) {
//                    alert(list[i].innerHTML);
                    //获取当前遍历span的id ==>id2
                    var id2 = list[i].id;
                    //若选中id与遍历id不同，则将背景设置为另外一种颜色
                    if(id != id2){
                        document.getElementById(id2).style.backgroundColor="rgba(200, 200, 200, 0)";
                    }
                }
            },
            getHour(sec) {
                if (sec <=0) return 0;
                return (sec / 60 / 60).toFixed(0); // 保留0位小数

            },
            //获取日期时间星期
            getDayTime(){
                var that = this;
                //获取当前时间并打印
                var y = that.endDate.getFullYear();
                var m = that.endDate.getMonth() + 1;
                var dd = new Date().getDate();
                var hh = new Date().getHours();
                var mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
                that.getday = y+'年'+m+'月'+dd+'日 ';
                that.gettime =hh+':'+mf;
                that.getweek = that.weekday[that.endDate.getDay()] ;
            },
            onSceneClose(){
                this.sceneType = 0
                this.sceneShow = false;
            },
            //编辑
            editScene(vo) {
                const vm = this;
                console.log(vo);
                vm.itemVal = vo;
                vm.sceneType = 2;
                vm.sceneWinTilte = "编辑场景 - "+vm.itemVal.sceneName;
                vm.sceneShow = true;
            },
            onOpen(item){
                var sceneOpen = item.sceneOpen;
                var id = item.sceneId;
                const that = this;
                that.$Modal.confirm({
                    title: '系统提示',
                    content: sceneOpen == 2 ? '确定开启场景吗？' : '确定关闭场景吗？',
                    onOk: () => {
                        if (sceneOpen == 2) {
                            sceneOpen = 1;
                        } else {
                            sceneOpen = 2;
                        }
                        that.$func.ajax('sceneOpenOrClose', {
                            sceneId: id,
                            sceneOpen: sceneOpen
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success(r.message);
                                item.sceneOpen = sceneOpen;
                            }
                        })
                    }
                })
            },
            getSDList(path,index){
                var that=this;
                that.$func.ajax('listSD', {
                    gatewayId: that.musicDevice.netMac,
                    path:path
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        var paths=''
                        var strs=that.path.split('/');
                        for (var i=0;i<that.page-1 ;i++ )
                        {
                            paths+=strs[i]+'/';
                        }
                        that.path=paths;
                    } else {
                        that.page++;
                        that.sdList=r.type.result;
                        that.dataList.push({page: that.page,index:index, data: that.sdList});
                        console.log('数据'+JSON.stringify(that.dataList));

                    }
                })
            },
            nextPage(item,index){
                var that=this;
                if(item.split('.').length==1){//文件夹
                    that.path=that.path+item+'/';
                    console.log('path='+that.path);
                    that.getSDList(that.path,index);
//                        that.page++;
//                        if(that.page==2){
//                            that.list=['222.mp3','wo.mp4','一壶','1234'];
//                        }else if(that.page==3){
//                            that.list=['333.mp3','你好','小小鸟.mp3','dhfui'];
//                        }
//                        that.dataList.push({page: that.page,index:index, data: that.list});
                    console.log('数据'+JSON.stringify(that.dataList));
                }else {//音乐、播放
                    that.musicInfo.filePath=item;
                    that.playMusic(item,4);
                }
            },
            lastPage(){
                var that=this;
                if(that.page>1){
                    that.sdList=that.dataList[that.page-2].data;
                    that.page--;
                    that.dataList.pop();
                    if(that.page==1){
                        that.path='';
                    }else{
                        var paths=''
                        var strs=that.path.split('/');
                        for (var i=0;i<that.page-1 ;i++ )
                        {
                            paths+=strs[i]+'/';
                        }
                        that.path=paths;
                    }
                    console.log('path='+that.path);
                    console.log('数据'+JSON.stringify(that.dataList));
                    console.log(that.page);
                }
            },
            nextSong() {
                var that = this;
                var len = this.sdList.length;
                if (that.songIndex == len - 1) {
                    that.songIndex = 0;
                } else {
                    that.songIndex = that.songIndex + 1
                }
                that.playMusic(that.sdList[that.songIndex], 4);
            },
            lastSong () {
                var len = this.sdList.length;
                if (this.songIndex == 0) {
                    this.songIndex = len - 1;
                } else {
                    this.songIndex = this.songIndex - 1
                }
                this.playMusic(this.sdList[this.songIndex], 4);
            },
            playOnOut(){
                var that=this;
                that.playMusic(that.musicInfo.filePath,2);
            },
            updateSong(){
//                this.musicInfo = info;
                console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
//                this.getMusicInfo();
            },
            //进度条监听
            progressChange(){
                var that = this;
                that.musicInfo.time_pos = that.musicInfo.progress / 100 * that.musicInfo.length;
                that.playMusic(that.musicInfo.filePath, 5);
            },
            playMusic(item, command){
                var that = this;
                if (that.musicInfo.filePath == '未选择歌曲') {
                    that.$func.msg('请选择歌曲');
                    return
                }
                var path = command == 2 ? '' : that.path + item;
                that.$func.ajax('playMusic', {
                    mobileId: that.$func.getToken(),
                    gatewayId: that.musicDevice.netMac,
                    deviceNo: that.musicDevice.deviceId,
                    path: path,
                    cha: that.musicInfo.cha,
                    time: 0,
                    command: command,
                    time_pos: that.musicInfo.time_pos
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$func.msg('操作成功');
                        if (command == 2) {
                            that.musicInfo.statu = !that.musicInfo.statu;
                        } else {
                            that.musicInfo.statu = 1;
                        }
                        if (r.type.time_pos) {
                            that.musicInfo.time_pos = r.type.time_pos;
                        }
                        if (r.type.length) {
                            that.musicInfo.length = r.type.length;
                        }
                        that.musicInfo.filePath = item;
                    }
                })
            },
            //音量监听
            volumeChange(){
                var that = this;
                that.$func.ajax('setVolume', {
                    gatewayId: that.musicDevice.netMac,
                    volume: that.musicInfo.volume
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {

                    }
                })
            },
            //添加数据
            listCatList(){
                const that = this;
                that.$func.ajax('catList', {
                    catPosition: 3,
                    flag: 1,
                    token: that.$func.getToken(),
                    areaId: that.$store.state.app.areaId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.list=[];
                        that.sensorList=[];
                        that.switchDeviceList=[];
                        that.kttsDeviceList=[];
                        that.fwglDeviceList=[];
                        that.kttgDeviceList=[];
                        that.musicDevice={};
                        that.sxtDeviceList=[];
                        that.camerasDeviceList=[];
                        that.list = r.type;
                        console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
                        console.log(that.list);
//                        that.getDevideNotice(r.type);
                        that.list.map(function (item, index) {
                            item.devices.map(function (item2, index2) {
                                item2.status=true;
                                item2.isOpen=0;
                                if (that.isSensor(item2)) {
                                    that.sensorList.push(item2);
                                }
                                if ((item2.eid.indexOf("relay") != -1 || item2.eid.indexOf("znmb") != -1 || item2.eid.indexOf("valve") != -1)) {
                                    that.switchDeviceList.push(item2)
                                }
                                if (item2.eid.indexOf("ktts") != -1) {
                                    that.kttsDeviceList.push(item2);
                                    that.fwglDeviceList.push(item2);
                                }
                                if (item2.eid.indexOf("kttg") != -1) {
                                    that.kttgDeviceList.push(item2)
                                    that.fwglDeviceList.push(item2);
                                }
                                if (item2.eid.indexOf("music") != -1) {
                                    that.musicDevice = item2;
                                    that.sxtDeviceList.push(item2);
                                    that.getSDList('',0);
                                }
                                if (item2.catId.indexOf("20181217151848EhMWolmj") != -1 && that.camerasDeviceList.length<2) {//摄像头
                                    that.camerasDeviceList.push(item2);
                                    that.sxtDeviceList.push(item2);
                                }

                            })
                        })
//                        if(that.sensorList.length>0){
                            console.log("传感器列表")
                            console.log(that.sensorList)
                            that.getSensorData();

//                        }
                        that.switchDeviceList.map(function (item,index) {
                            setTimeout(function () {
                                that.getDevideNotice(item);
                            },500)
                        })
                        setTimeout(function () {
                            that.kttsDeviceList.map(function (item,index) {
                                setTimeout(function () {
                                    that.getDevideNotice(item);
                                },500)
                            })
                        },that.switchDeviceList.length*500)
                        setTimeout(function () {
                            that.kttgDeviceList.map(function (item,index) {
                                setTimeout(function () {
                                    that.getDevideNotice(item);
                                },500)
                            })
                        },that.kttsDeviceList.length*500)
                        setTimeout(function () {
                            if(that.musicDevice.deviceId>0){
                                that.getMusicInfo();
                            }
                        },that.kttgDeviceList.length*500)
                        setTimeout(function () {
                            that.camerasDeviceList.map(function (item,index) {
                                setTimeout(function () {
                                    that.getDevideNotice(item);
                                },500)
                            })
                        },500)



                    }
                })
            },
            getInfo(item){
                console.log(item)
                const that = this;
                that.$func.ajax('getInfoCache', {
                    token: that.$func.getToken(),
                    deviceNo: item.deviceId
                }, function (r) {
                    if (r.statusCode) {//成功
                        console.log('查询来了');
                        item.isOpen= r.type.info.isOpen;
                        that.$forceUpdate();
                    } else {//离线
                        console.log(r.message)
                    }
                }, function (err) {
                    console.log(err)
                })
            },
            dapingRefresh() {
                const that = this;
                console.log(that.$store.state.app)
                this.areaId = that.$store.state.app.areaId;
                this.areaName = that.$store.state.app.areaName;

                that.onClose();
                that.listScene();
                that.getMaintainData();
                that.listCatList();
                that.getDayTime();
                that.getAreaMap();
                that.getSensorStandard();
                //第二次调用，防止为加载完设备就对比
                setTimeout(function () {
                    that.getColumnDate();
                },6000)
            },
            dateRefresh() {
                const that = this;
                that.sprayStatusList=[{name:"喷灌状态",num:70,vdef:"优",color:"#00FF01"},{name:"土壤墒情",num:0,vdef:"--",color:"#FE6601"},{name:"肥力状态",num:0,vdef:"--",color:"#FE6601"}];
//                that.listCatList();
                console.log("刷新传感器列表")
                that.getSensorData();
                that.getDayTime();
                //第二次调用，防止为加载完设备就对比
                setTimeout(function () {
                    that.getColumnDate();
                },6000)
            },
            //获取设备预警状态
            getDevideNotice(device){
                const that = this;
                    //设备默认不正常
                    device.status = false;
                    //设备默认关闭
                    device.switchStatus = false;

                    //判断厂商
                    if (device.factoryType == 1) //天正
                    {
                        //判断设备是否开机
                        that.$func.tz.getDevideInfo(device.deviceMac, function (res) {
                            if (res && res.eqmsg) {

                                //替换最新网关
                                device.netMac = res.gmac;

                                //接口通，设备正常
                                device.status = true;

                                //设备返回值
                                device.eqmsg = res.eqmsg;

                                //首先格式化消息
                                if (res.eqmsg.split(',').length > 1) //多数据 可能存在 多路
                                {
                                    //判断是否是控制器
                                    device.switch = [];
                                    let switchStatus = false;
                                    res.eqmsg.split(',').map(function (vv, ii) {
                                        //是开关
                                        if (that.$store.state.app.tz.offCode.indexOf(vv) > -1 || that.$store.state.app.tz.onCode.indexOf(vv) > -1) {
                                            device.switchNum = res.eqmsg.split(',').length;
                                            //判断开和关
                                            if (that.$store.state.app.tz.offCode.indexOf(vv) > -1) {
                                                device.switch[ii] = {
                                                    name: (ii + 1) + '路',
                                                    value: vv,
                                                    status: false
                                                };
                                            } else if (that.$store.state.app.tz.onCode.indexOf(vv) > -1) {
                                                switchStatus = true;
                                                device.switch[ii] = {
                                                    name: (ii + 1) + '路',
                                                    value: vv,
                                                    status: true
                                                };
                                            }
                                            //不是开关
                                        } else {
                                            device.switchNum = 0;
                                        }
                                    })
                                    device.switchStatus = switchStatus;

                                } else //单数据
                                {
                                    if (that.$store.state.app.tz.offCode.indexOf(res.eqmsg) > -1) {
                                        device.switchNum = 1;
                                        device.switchStatus = false;
                                        device.switch = [
                                            {
                                                name: '1路',
                                                value: res.eqmsg,
                                                status: false
                                            }
                                        ];
                                    } else if (that.$store.state.app.tz.onCode.indexOf(res.eqmsg) > -1) {
                                        device.switchNum = 1;
                                        device.switchStatus = true;
                                        device.switch = [
                                            {
                                                name: '1路',
                                                value: res.eqmsg,
                                                status: true
                                            }
                                        ];
                                    } else {
                                        device.switchNum = 0;
                                    }
                                }
                            } else {
                                device.switchStatus = false;
                                device.status = false;
                            }

                            //判断设备是否异常
                            // if(index == _list.length-1){
                            that.$func.tz.getDevideNotice(function (r) {
                                that.$func.uniqueArr('emac', r).map(function (vo3, index3) {
                                    if (vo3.emac == device.deviceMac) {
                                        if (vo3.htype < 2) {
                                            device.status = false;
                                        } else {
                                            device.status = true;
                                        }
                                    }
                                    that.$forceUpdate();
                                })
                            })
                            // }

                        }, function () {
                            device.switchStatus = false;
                            device.status = false;
                        })

                    } else if (device.factoryType == 2) //萤石
                    {
                        //不是开关
                        device.switchNum = 0;
                        //判断接口是否故障
                        that.$func.ys.getDevideInfo(device.deviceMac, function (res) {
                            if (res.data.status) {
                                device.switchStatus = true;
                                device.status = true;
                            } else {
                                device.switchStatus = false;
                                device.status = false;
                            }
                            that.$forceUpdate();
                        }, function () {
                            device.switchStatus = false;
                            device.status = false;
                            that.$forceUpdate();
                        })
                        //获取直播地址
                        device.dinfo = {};
                        that.$func.ys.getDevideAddress(device.deviceMac, function (res) {
                            device.dinfo = res.data;
                        })

                    } else if (device.factoryType == 3) //晶控
                    {
                        console.log(device);
                        var deviceMac='';
                        var list='';
                        if(device.isGroup==0){//单个设备
                            deviceMac=device.deviceMac;
                        }else {//组合设备,拿组合的第一个设备的状态来决定组合设备的状态
                            var groupDevice=JSON.parse(device.groupDevice);
                            deviceMac=groupDevice[0].deviceMac;
                            list=groupDevice[0].wires.split(',')[0];//第一个设备第一路
                        }
                        //判断是否开启
                        that.$func.ajax('sendCommand', {
                            token: that.$func.getToken(),
                            deviceCode: deviceMac,
                            command: 'RELAY-STATE-x',
                        }, function (r) {
                            console.log('%%%%%%%%%%%%%%%%');
                            console.log(r);
                            if (!r.statusCode) {
                                device.switchStatus = false;
                                device.status = false;
                                that.$func.msg(r.message, 'error');
                            } else {
                                if (r.type.status !== '0') {
                                    device.switchStatus = false;
                                    device.status = false;
                                } else {
                                    device.status = true;
                                    //判断灯具和智能面板
                                    if (device.eid == 'dj') //灯具
                                    {
                                        //调用查询接口判断位数
                                        var str2 = that.$func.getJkSwitchOrder(r.type.result);
                                        //判断开关
                                        if (str2 === '0' || str2 === '0,0,0,0') {
                                            device.switchNum = 1;
                                            device.switchStatus = false;
                                            device.switch = [
                                                {
                                                    name: '1路',
                                                    value: r.type.result,
                                                    status: false
                                                }
                                            ];
                                        } else {
                                            device.switchNum = 1;
                                            device.switchStatus = true;
                                            device.switch = [
                                                {
                                                    name: '1路',
                                                    value: r.type.result,
                                                    status: true
                                                }
                                            ];
                                        }

                                    } else if (device.eid == 'znmb') //智能面板
                                    {
                                        if(device.isGroup==0){//单个设备
                                            //调用查询接口判断位数
                                            var str3 = that.$func.getJkSwitchOrder(r.type.result);
                                            //按钮名称
                                            var remarkArr = device.remark.split('\r\n');
                                            //判断设备路数
                                            var lens = remarkArr.length;
                                            //判断开关
                                            if (str3 === '0' || str3 === '0,0,0,0') //全关
                                            {
                                                device.switchNum = lens;
                                                device.switchStatus = false;
                                                //反编译开关
                                                var lensswitchs1 = [];
                                                for (let ii = 0; ii < lens; ii++) {
                                                    lensswitchs1.push({
                                                        name: remarkArr[ii],
                                                        value: r.type.result,
                                                        status: false
                                                    })
                                                }
                                                device.switch = lensswitchs1;

                                            } else //部分关
                                            {
                                                //哪几路开启
                                                var switchOn = that.$func.deTransformCode(lens, that.$func.getJkSwitchOrder(r.type.result));
                                                device.switchNum = lens;
                                                if (switchOn.length > 0) {
                                                    device.switchStatus = true;
                                                } else {
                                                    device.switchStatus = false;
                                                }
                                                console.log(switchOn)
                                                //反编译开关
                                                var lensswitchs = [];
                                                for (let ii = 0; ii < lens; ii++) {
                                                    lensswitchs.push({
                                                        name: remarkArr[ii],
                                                        value: r.type.result,
                                                        status: switchOn.indexOf(ii + 1) === -1 ? false : true
                                                    })
                                                }
                                                device.switch = lensswitchs;
                                            }
                                        }else {//组合设备
                                            //调用查询接口判断位数
                                            var remarkArr = device.remark.split('\r\n');
                                            //判断设备路数
                                            var lens = remarkArr.length;
                                            var switchOn = that.$func.deTransformCode(lens, that.$func.getJkSwitchOrder(r.type.result));
                                            //判断开关
                                            if ( switchOn.indexOf(Number(list)) != -1 ) {//第一个设备的第一路  开
                                                device.switchNum = 1;
                                                device.switchStatus = true;
                                                device.switch = [
                                                    {
                                                        name: '组合开关',
                                                        value: r.type.result,
                                                        status: true
                                                    }
                                                ];
                                            } else {//关
                                                device.switchNum = 1;
                                                device.switchStatus = false;
                                                device.switch = [
                                                    {
                                                        name: '组合开关',
                                                        value: r.type.result,
                                                        status: false
                                                    }
                                                ];
                                            }
                                        }

                                    }
                                }
                                that.$forceUpdate();
                            }
                        }, function () {
                            device.switchStatus = false;
                            device.status = false;
                            that.$forceUpdate();
                        }, 'post', true, function () {
                            device.switchStatus = false;
                            device.status = false;
                            that.$forceUpdate();
                        })
                    }else if (device.factoryType == 4) //凯图
                    {
                        //默认关
                        device.switchStatus = false;
                        that.$KtApi.getBrightness(that.$KtApi.getIdByEid(device.eid),{domainName:device.netMac,hostIp:device.deviceMac}, function (msg) {
                            for(let ii=0 ; ii < msg.bright.length ; ii++){
                                device.status = true;
                                //有一路开则开
                                if(msg.bright[ii].status){
                                    device.switchStatus = true;
                                    continue;
                                }
                            }
                            that.$forceUpdate();
//                                    console.log('凯图查询更新：'+JSON.stringify(msg))
                        }, function (err) {
                            device.switchStatus = false;
                            device.status = false;
                            that.$forceUpdate();
                        })
                    }else if (device.factoryType == 5) //精讯
                    {
                        if(that.$func.isSensor(device.eid)){//传感器
                            that.$func.jx.selSingleSensorData(device.deviceMac,device.eid,function (r) {
                                device.switchStatus = true;
                                device.status = true;
                                //设备返回值
                                device.eqmsg = r.eqmsg;
                                setTimeout(function () {
                                    that.$forceUpdate();
                                }, 1000)
                            },function (err) {
                                device.switchStatus = false;
                                device.status = false;
                                setTimeout(function () {
                                    that.$forceUpdate();
                                }, 1000)
                            });
                        }else {//继电器
                            var deviceNumber='';
                            var list='';
                            if(device.isGroup==0){//单个设备
                                deviceNumber=device.deviceMac;
                            }else {//组合设备,拿组合的第一个设备的状态来决定组合设备的状态
                                var groupDevice=JSON.parse(device.groupDevice);
                                deviceNumber=groupDevice[0].deviceMac;
                                list=groupDevice[0].wires.split(',')[0];//第一个设备第一路
                            }
                            //判断是否开启
                            that.$func.jx.getDeviceInfo(deviceNumber,device.eid, function (r) {
                                if(device.isGroup==0){//单个设备
                                    //按钮名称
                                    var remarkArr = device.remark.split('\r\n');
                                    //判断设备
                                    var lens = remarkArr.length;
                                    //判断开关
                                    device.switchNum = lens;
                                    device.switchStatus = r.isOpen;
                                    device.status = !r.broken;
                                    //反编译开关
                                    var lensswitchs = [];
                                    for (let ii = 0; ii < lens; ii++) {
                                        lensswitchs.push({
                                            name: remarkArr[ii],
                                            value: '',
                                            status: r.stateArr[ii]
                                        })
                                    }
                                    device.switch = lensswitchs;
                                }else {//组合设备
                                    device.switchNum = 1;
                                    device.switchStatus = r.isOpen;
                                    device.status = !r.broken;
                                    //第一个设备的第一路是开则开
                                    device.switch = [
                                        {
                                            name: '组合开关',
                                            value: '',
                                            status: r.stateArr[list-1]
                                        }
                                    ];
                                }
                                setTimeout(function () {
                                    that.$forceUpdate();
                                }, 1000)
                            }, function () {
                                device.switchStatus = false;
                                device.status = false;
                                setTimeout(function () {
                                    that.$forceUpdate();
                                }, 1000)
                            })
                        }
                    }else if (device.factoryType == 6) //芯蚁
                    {
                        console.log(device);
                        that.$func.ajax('getInfoCache', {
                            token:that.$func.getToken(),
                            deviceNo: device.deviceId
                        }, function (r) {
                            if (r.statusCode) {//成功
                                device.switchStatus = r.type.info.isOpen==0? false:true;
                                device.status = true;
                                device.switch = [];
                                if(that.$func.isRelay(device.eid) || device.eid.indexOf('valve') != -1) {//继电器、电磁阀
                                    if(device.isGroup==0){//单个设备
                                        //按钮名称
                                        var remarkArr = device.remark.split('\r\n');
                                        //判断设备
                                        var lens = remarkArr.length;
                                        //判断开关
                                        device.switchNum = lens;
                                        //反编译开关
                                        var lensswitchs = [];
                                        if(device.eid.indexOf('relay-1') != -1){
                                            console.log("电磁阀");
                                            device.switch = [
                                                {
                                                    name: '开关',
                                                    value: '',
                                                    status: r.type.info.isOpen==0? false:true
                                                }
                                            ];
                                        }else{
                                            for (let ii = 0; ii < lens; ii++) {
                                                lensswitchs.push({
                                                    name: remarkArr[ii],
                                                    value: '',
                                                    status:  r.type.info.switchArr[ii]
                                                })
                                            }
                                            device.switch = lensswitchs;
                                        }
                                    }else {//组合设备
                                        device.switchNum = 1;
                                        device.switch = [
                                            {
                                                name: '组合开关',
                                                value: '',
                                                status: r.type.info.isOpen==0? false:true
                                            }
                                        ];
                                    }
                                }else if(device.eid.indexOf('sensor') != -1) {//传感器
                                    var eqmsg=that.$func.sensorData(device.eid,6);
                                    eqmsg.map(function (vv, ii) {
                                        eqmsg[ii].value=r.type.info.value[vv.index];
                                    });
                                    device.eqmsg = eqmsg;//数组
                                }
                            } else {//离线
                                device.switchStatus = false;
                                device.status = false;
                            }
                            setTimeout(function () {
                                that.$forceUpdate();
                            }, 1000)
                        }, function () {
                            device.switchStatus = false;
                            device.status = false;
                            setTimeout(function () {
                                that.$forceUpdate();
                            }, 1000)
                        })
                    }
            },
            isSensor(item) {
                return item.eid == '3' || item.eid == '4' || item.eid == '5' || item.eid == '15' || item.eid == '24' ||
                    item.eid.indexOf('sensor') != -1
            },
            //关闭侧滑
            onClose(){
                this.type = 0
                this.show = false;
            },
            selectArea(){
                const that = this;
                that.type = 1;
                that.winTitle = "选择区域";
                that.show = true;
            },
            // 固定是音乐弹出
            see(item){
                const that = this;
                this.sbInfo = item
                that.winTitle = item.deviceName;
                if (item.eid.indexOf('music') != -1) {
                    that.type = 3;
                    that.sbInfo.modeType = 2;
                } else {
                    that.type = 2;
                }
                that.show = true;
            },
            //获取养护数据
            getMaintainData(){
                let that = this;
                that.$func.ajax('listMaintain',{
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.maintainList=[];
                        r.type.map(function (item,index2) {
                            if (that.maintainList.length<2){
                                that.maintainList.push(item);
                            }
                        })

                    }
                })
            },
            listScene(){
                var that = this;
                that.preloading = true;
                that.$func.ajax('listScene', {
                    token: that.$func.getToken(),
                    areaId: that.$store.state.app.areaId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.sceneCatList = [];
                        console.log('**********获取场景*************');
                        that.sceneCatList = r.type;
                        that.preloading = false;
                        console.log(that.sceneCatList);
                    }
                })
            },
            listArea(){
                var that = this;
                that.$func.ajax('listArea', {
                    token: that.$func.getToken(),
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        if (r.type.length > 0) {
                            that.areaList = r.type;
                            //全局记录areaId
                            let setAreaId;
                            setAreaId = {
                                areaId: that.areaList[0].areaId,
                                areaName: that.areaList[0].areaName
                            };
                            that.$store.commit('setAreaId', setAreaId);
                            that.dapingRefresh();
                        }


                    }
                })
            },
            getMusicInfo(){
                var that = this;
                that.isIng = true;

                that.$func.ajax('refreshInfo', {
                    token: that.$func.getToken(), deviceNo: that.musicDevice.deviceId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.musicInfo.statu = r.type.statu;
                        if (that.musicInfo.statu && r.type.filePath) {
                            that.musicInfo.filePath = r.type.filePath;
                        }
                        if (that.musicInfo.statu && r.type.time_pos) {
                            that.musicInfo.time_pos = r.type.time_pos;
                        }
                        if (that.musicInfo.statu && r.type.length) {
                            that.musicInfo.length = r.type.length;
                        }
                        that.musicInfo.progress = that.musicInfo.time_pos / that.musicInfo.length * 100;
                        console.log(that.musicInfo.progress);
                        that.musicInfo.volume = r.type.volumn;
                    }
                })

                setInterval(function () {
//                    console.log('数据' + that.musicInfo.statu + '#' + that.musicInfo.progress);
                    if (that.musicInfo.statu == 1 && that.musicInfo.progress < 100) {
                        that.musicInfo.time_pos += 1;
                        that.musicInfo.progress = that.musicInfo.time_pos / that.musicInfo.length * 100;
//                        console.log('数据' + that.musicInfo.time_pos + '$' + that.musicInfo.progress);
                    } else if (!that.musicInfo.progress < 100) {
                        that.musicInfo.statu = 0;
                    }
                }, 1000)
            },
            //传感器历史记录图标绘制
            drawExampleChart: function (eid,factoryType,deviceName, eqls, index) {
                const that = this;
                that.centerChartLSJL[index] = echarts.init(document.getElementById("ww_echart_"+index));
                // 动态数据的获取及修改
                let option = that.$TzUntil.dapingGetRecord(eqls,eid,factoryType,deviceName,index);
                console.log("==================drawExampleChart================")
                console.log(eqls)
                that.centerChartLSJL[index].setOption(option,true);
            },
            //土壤类传感器数值
            drawTRSensorDataChart: function (eid, name, valueType, value, index) {
                const that = this;
                that.centerChartTR[index] = echarts.init(document.getElementById("ww_echart_center_TR_" + (index + 1)));
                var sensor = that.$func.getSensorText(eid);
                var union=sensor.union
                console.log("==================drawTRSensorDataChart================")
                console.log(value)
                that.centerChartTR[index].clear();
                that.centerChartTR[index].setOption(echartUtil.getChartOption(name, valueType, value,union));
            },
            //环境类传感器数值
            drawHJSensorDataChart: function (eid, name, valueType, value, index) {
                const that = this;
                that.centerChartHJ[index] = echarts.init(document.getElementById("ww_echart_center_HJ_" + (index + 1)));
                var sensor = that.$func.getSensorText(eid);
                var union=sensor.union
//                console.log("==================drawHJSensorDataChart================")
//                console.log(device)
                that.centerChartHJ[index].clear();
                that.centerChartHJ[index].setOption(echartUtil.getChartOption(name, valueType, value,union));
            },
            //获取传感器数值
            getSensorData(){
                const that = this;
                that.trSensorList = [];
                that.rightSensorList = [{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0}];
                that.kqSensorList = [];
                that.szSensorList=[];
                that.trsdSensorList=[];
                that.trflSensorList=[];
                that.llSensorList=[];
                that.zhpgDeviceList=[];
                that.trglDeviceList=[];
                that.hjglDeviceList=[];
                that.sensorList.map(function (item, index) {
                    that.$func.ajax('getInfoCache', {
                        deviceNo: item.deviceId
                    }, function (r) {
                        if (r.statusCode) {//有记录
                            var info=r.type.info;
                            console.log("==================获取传感器数值================")
                            console.log(info)
                            item.value=info.value;//显示当前值要用到
                            item.info=info;
                            if(info.valueType=="trsd"){
                                that.trsdSensorList.push(item);//土壤湿度
                                that.trglDeviceList.push(item);//土壤管理栏目中
                                that.zhpgDeviceList.push(item);//智慧喷灌栏目用
                                if(that.trSensorList.length<2){
                                    that.trSensorList.push(item);//土壤历史记录用
                                }
                            }else if(info.valueType=="trfl"){
                                that.trflSensorList.push(item);//土壤肥力
                                that.trglDeviceList.push(item);//土壤管理栏目中
                                that.zhpgDeviceList.push(item);//智慧喷灌栏目用
                                if(that.trSensorList.length<2){
                                    that.trSensorList.push(item);////土壤历史记录用
                                }
                            }else if(info.valueType=="ll"){
                                that.llSensor=item;
                                that.trglDeviceList.push(item);//土壤管理栏目中
                                that.llSensorList.push(item);//中间的流量用
                                that.zhpgDeviceList.push(item);//智慧喷灌栏目用
                            }else if(info.valueType=="yl"){
                                that.ylSensor=item;
                                that.trglDeviceList.push(item);//土壤管理栏目中
                            }else if(info.valueType=="trws"){
                                that.trwdSensor=item;
                                that.trglDeviceList.push(item);//土壤管理栏目中
                            }else if(info.valueType=="kqsd"){
                                that.kqsdSensor=item;
                                that.trglDeviceList.push(item);//土壤管理栏目中
                            }else if(info.valueType=="pm2510"){
                                that.pmSensor=item;
                                that.hjglDeviceList.push(item);//环境管理栏目中
                                that.kqSensorList.push(item);//空气用
                            }else if(info.valueType=="ddl"){
                                that.ddlSensor=item;
                                that.hjglDeviceList.push(item);//环境管理栏目中
                                that.szSensorList.push(item);//水质用
                            }else if(info.valueType=="dqy" || info.valueType=="kqzl"|| info.valueType=="sw" || info.valueType=="ws"
                                || info.valueType=="swen" || info.valueType=="rjy"|| info.valueType=="ddl" || info.valueType=="ph"|| info.valueType=="gzd"|| info.valueType=="hw"
                                || info.valueType=="ad"|| info.valueType=="zs"|| info.valueType=="CO2"|| info.valueType=="O2"){//右侧环形进度条
                                that.rightSensorList.map(function (item1, index1) {
                                    if(item1.deviceId==0){
                                        that.rightSensorList[index1]=item;
                                        that.hjglDeviceList.push(item);
                                    }
                                })
                            }
                            

                        }
                    });
                })
                //将仪表盘数据清零
//                that.drawTRSensorDataChart("wsb0", "土壤湿度", "wsb0", 0,0);
//                that.drawTRSensorDataChart("wsb0", "土壤肥力", "wsb0", 0,1);
//                that.drawHJSensorDataChart("wsb0", "空气PM2.5", "wsb0", 0,0);
//                that.drawHJSensorDataChart("wsb0", "水体导电率", "wsb0", 0,1);
                setTimeout(function () {
                    //传感器历史记录
                    that.sensorRecordList=[];
                    if(that.trSensorList.length>0){//左侧只需要一个历史记录
                        that.sensorRecordList.push(that.trSensorList[0]);
                    }else{
                        that.sensorRecordList.push({eid:'sensor-trsd',factoryType:6,deviceName:'土壤湿度'});
                    }
                    if(JSON.stringify(that.pmSensor) != '{}'){//右侧4个
                        that.sensorRecordList.push(that.pmSensor);
                    }else{
                        that.sensorRecordList.push({eid:'sensor-pm2510',factoryType:6,deviceName:'PM2.5'});
                    }
                    if(JSON.stringify(that.ddlSensor) != '{}'){
                        that.sensorRecordList.push(that.ddlSensor);
                    }else{
                        that.sensorRecordList.push({eid:'sensor-ddl',factoryType:6,deviceName:'水体导电率'});
                    }
                    console.log("==================rightSensorList传感器================")
                    console.log(that.rightSensorList)
                    that.rightSensorList.map(function (item, index) {
                        if(item.deviceId!=0&&that.sensorRecordList.length<5){
                            that.sensorRecordList.push(item);
                        }
                    })
                    console.log("==================sensorRecordList传感器================")
                    console.log(that.sensorRecordList)
                    if(that.sensorRecordList.length<4){
                        that.sensorRecordList.push({eid:'sensor-sw',factoryType:6,deviceName:'水位'});
                    }
                    if(that.sensorRecordList.length<5){
                        that.sensorRecordList.push({eid:'sensor-rjy',factoryType:6,deviceName:'溶解氧'});
                    }
                    console.log("==================传感器历史数组================")
                    console.log( that.sensorRecordList)
                    that.listSensorRecord();//获取传感器历史记录

                    console.log("==================土壤湿度仪表盘================")
                    console.log( that.trsdSensorList)
                    //土壤湿度仪表盘
                    if(that.trsdSensorList.length>0){
                        var total=0;
                        that.trsdSensorList.map(function (trsditem, index) {
                            total+=trsditem.value-0;
                        })
                        var info=that.trsdSensorList[0].info;
                        info.value=(total/that.trsdSensorList.length).toFixed(2);//土壤湿度平均值
                        that.sensorStandardList.map(function (item,index) {//智慧喷灌中进度条显示
                            if (item.eid.indexOf('trsd') != -1){
                                if(info.value<item.low){//低值
                                    that.sprayStatusList[1]={name:"土壤墒情",num:info.value,vdef:item.vdef1,color:"#FE6601"};
                                }else if(info.value>item.hight){//高值
                                    that.sprayStatusList[1]={name:"土壤墒情",num:info.value,vdef:item.vdef3,color:"#01FFFF"};
                                }else{
                                    that.sprayStatusList[1]={name:"土壤墒情",num:info.value,vdef:item.vdef2,color:"#3DFA37"};
                                }
                            }
                        })
                        that.drawTRSensorDataChart(that.trsdSensorList[0].eid, "土壤湿度", info.valueType, info.value,0);
                    }else{
                        that.drawTRSensorDataChart("wsb0", "土壤湿度", "wsb0", 0,0);
                    }
                    //土壤肥力仪表盘
                    if(that.trflSensorList.length>0){
                        var total=0;
                        that.trflSensorList.map(function (trflitem, index) {
                            total+=trflitem.value-0;
                        })
                        var info=that.trflSensorList[0].info;
                        info.value=(total/that.trflSensorList.length).toFixed(2);
                        that.sensorStandardList.map(function (item,index) {//智慧喷灌中进度条显示
                            if (item.eid.indexOf('trfl') != -1){
                                if(info.value<item.low){//低值
                                    that.sprayStatusList[2]={name:"肥力状态",num:info.value,vdef:item.vdef1,color:"#FE6601"};
                                }else if(info.value>item.hight){//高值
                                    that.sprayStatusList[2]={name:"肥力状态",num:info.value,vdef:item.vdef3,color:"#28AFF7"};
                                }else{
                                    that.sprayStatusList[2]={name:"肥力状态",num:info.value,vdef:item.vdef2,color:"#FFCC30"};
                                }
                            }
                        })
                        that.drawTRSensorDataChart(that.trflSensorList[0].eid, "土壤肥力", info.valueType, info.value,1);
                    }else{
                        that.drawTRSensorDataChart("wsb0", "土壤肥力", "wsb0", 0,1);
                    }
                    //PM2.5仪表盘、进度条
                    if(JSON.stringify(that.pmSensor) != '{}'){
                        that.drawHJSensorDataChart(that.pmSensor.eid, "空气PM2.5", that.pmSensor.info.valueType, that.pmSensor.info.value,0);
                        that.sensorStandardList.map(function (item,index) {//进度条显示
                            if (item.eid.indexOf('pm2510') != -1){
                                if(that.pmSensor.info.value<item.low){//低值
                                    that.hjMassList[0]={num:that.pmSensor.info.value,vdef:item.vdef1,color:"#FEC609"};
                                }else if(info.value>item.hight){//高值
                                    that.hjMassList[0]={num:that.pmSensor.info.value,vdef:item.vdef3,color:"#21FFFF"};
                                }else{
                                    that.hjMassList[0]={num:that.pmSensor.info.value,vdef:item.vdef2,color:"#22FF04"};
                                }
                            }
                        })
                    }else{
                        that.drawHJSensorDataChart("wsb0", "空气PM2.5", "wsb0", 0,0);
                    }
                    //水体导电率、进度条
                    if(JSON.stringify(that.ddlSensor) != '{}'){
                        that.drawHJSensorDataChart(that.ddlSensor.eid, "水体导电率", that.ddlSensor.info.valueType, that.ddlSensor.info.value,1);
                        that.sensorStandardList.map(function (item,index) {//进度条显示
                            if (item.eid.indexOf('ddl') != -1){
                                if(that.ddlSensor.info.value<item.low){//低值
                                    that.hjMassList[1]={num:that.ddlSensor.info.value,vdef:item.vdef1,color:"#FEC609"};
                                }else if(info.value>item.hight){//高值
                                    that.hjMassList[1]={num:that.ddlSensor.info.value,vdef:item.vdef3,color:"#21FFFF"};
                                }else{
                                    that.hjMassList[1]={num:that.ddlSensor.info.value,vdef:item.vdef2,color:"#22FF04"};
                                }
                            }
                        })
                    }else{
                        that.drawHJSensorDataChart("wsb0", "水体导电率", "wsb0", 0,1);
                    }
                },400*that.sensorList.length);


            },
            //获取数据评价标准
            getSensorStandard(){
                let that = this;
                that.$func.ajax('listSensorStandard',{
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.sensorStandardList=[];
                       that.sensorStandardList= r.type;
                    }
                })
            },
            //  列出历史数据
            listSensorRecord(){
                const that = this;
                //时间格式化
                var startDate=that.$func.formatDate(that.startDate,"yyyy-MM-dd");
                var endDate=that.$func.formatDate(that.endDate,"yyyy-MM-dd");
//                var startDate=that.startDate;
//                var endDate=that.endDate;ss
                var hash=[];
                // 获取不重复的 精讯传感器的精讯mac
                that.sensorRecordList.map(function (item, index) {
                    if (item.factoryType==5 && item.eid.indexOf('sensor')!=-1){
                        if (hash.indexOf(item.deviceMac)==-1){
                            hash.push(item.deviceMac)
                        }
                    }
                });
                //  精讯的组
                hash.map(function(item,index) {
                    that.$func.jx.getSensorEqls(item.deviceMac,startDate,endDate, function (res) {
                        console.log('&&&&&&&&&&精讯&&&&&&&&&');
                        console.log(res);
                        var datas=res;
                        // 不要再排序等操作  index2位置和初始化图表时一致
                        that.list.map(function (item2,index2) {
                            if (item2.deviceMac==item){
                                console.log('非第一个精讯的传感器已经有数据，直接创建'+JSON.stringify(datas))
                                that.drawExampleChart(item.eid,item.factoryType,item.deviceName, datas.reverse(), index2);
                            }

                        })
                    }, function () {
//                            that.$func.notice('【'+item.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                    })
                })
                that.sensorRecordList.map(function (item, index){
                    if(item.deviceId==null){
                        that.drawExampleChart(item.eid,item.factoryType,item.deviceName, [],index);
                    }else{
                        if(item.factoryType==1){//天正
                            that.$func.tz.getDevideEqls(item.deviceMac,startDate,endDate, function (res) {
                                console.log(res);
                                that.drawExampleChart(item.eid,item.factoryType,item.deviceName,res,index);
                            }, function () {
//                            that.$func.notice('【'+item.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                            })
                        }else  if(item.factoryType==6){
                            that.$func.ajax('listSensorRecord', {
                                startDate: startDate,
                                endDate: endDate,
                                deviceNo: item.deviceId
                            }, function (r) {
                                if (r.statusCode) {//有记录
                                    that.drawExampleChart(item.eid,item.factoryType,item.deviceName, r.type,index);
                                }
                            });
                        }
                    }
                })
            },
        }
    };
</script>
